import { TRootState } from '@/redux/rootReducer';

export const getIsCampsite = (state: TRootState) =>
  state.listing.data?.rental_category === 'campground';

export const getIsStationaryCamperCampsite = (state: TRootState) =>
  state.listing.data?.campsite_category?.category_type === 'stationary_camper_site';

export const getIsCampgroundListing = (state: TRootState) => state.campgroundListing.data !== null;
